<template>
  <div class="total-container">
    <div class="total-header" v-show="$store.state.isFlagVisible" >
      <div style="margin-left:40px;width: 25%;">AH Security System</div>
      <div class="header-center">
        <div class="center-menu" v-for="item in menuList" :key="item.label" style="cursor: pointer;"
          @click="selectMenu(item)">
          <img v-if="activeMenu == item.label" class="menu-img" :src="item.icon_on"
            style="border-bottom: 3px #387FF7 solid;">
          <img v-else class="menu-img" :src="item.icon_un">
          <div v-if="activeMenu == item.label">{{ item.label }}</div>
          <div v-else style="color:#979797;">{{ item.label }}</div>
        </div>
      </div>
      <div class="header-right">
        <div style="margin-right:10px;">
          {{ timenow??'--' }}
        </div>
        <div style="margin-right:10px;">
          {{ weather?.temperature??'--'}}℃
        </div>
        <div  class="weatherimgbox" v-if="weather?.weather" >
          <img :src="weatherPic[weather?.weather]" class="weatherimg"  >
        </div>
       
        <div style="margin-right:10px;">|</div>
        <ah-pop placement="bottom">
          <template #content>
            <div style="background: #343434;cursor:pointer;text-align:center;height:30px;line-height:30px;font-size:14px;"
              @click="aquaLogout">退出登录</div>
          </template>
          <div style="display:flex;flex-direction:row;align-items: center;">
            <img class="avatarimg"  src="@/assets/avatar.png" />
            <div>{{ username }}</div>
          </div>
        </ah-pop>
      </div>
    </div>
    <div class="total-bottom">
      <sub-view-main></sub-view-main>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SubViewMain from './SubViewMain.vue';
import router from '@/router';
import AhPop from "@/components/AhPop.vue";

export default {
  name: 'HomeView',
  components: {
    SubViewMain, AhPop,
  },
  data() {
    return {
      timeSetinterval: null,
      timenow: "",
      // 经纬度：先给默认值，定位成功后自动覆盖
      latitude: 31.2304,
      longitude: 121.4737,
      menuList: [{
        icon_on: require("@/assets/realtime/menu-realtime-on.png"),
        icon_un: require("@/assets/realtime/menu-realtime-un.png"),
        label: "态势与控制",
        url: "/realtime"
      }, {
        icon_on: require("@/assets/realtime/menu-route-on.png"),
        icon_un: require("@/assets/realtime/menu-route-un.png"),
        label: "航线库",
        url: "/route"
      }, {
        icon_on: require("@/assets/realtime/menu-media-on.png"),
        icon_un: require("@/assets/realtime/menu-media-un.png"),
        label: "媒体库",
        url: "/media"
      }],
      activeMenu: "态势与控制",
      weather: {},
      // 天气代码映射
      weatherCodeMap: {
        0: { text: "晴", icon: "晴" },
        1: { text: "晴", icon: "晴" },
        2: { text: "多云", icon: "多云" },
        3: { text: "阴", icon: "阴" },
        45: { text: "霾", icon: "霾" },
        48: { text: "霾", icon: "霾" },
        51: { text: "雨", icon: "雨" },
        53: { text: "雨", icon: "雨" },
        55: { text: "雨", icon: "雨" },
        56: { text: "雨", icon: "雨" },
        57: { text: "雨", icon: "雨" },
        61: { text: "雨", icon: "雨" },
        63: { text: "雨", icon: "雨" },
        65: { text: "雨", icon: "雨" },
        66: { text: "雨", icon: "雨" },
        67: { text: "雨", icon: "雨" },
        71: { text: "雪", icon: "雪" },
        73: { text: "雪", icon: "雪" },
        75: { text: "雪", icon: "雪" },
        77: { text: "雪", icon: "雪" },
        80: { text: "雨", icon: "雨" },
        81: { text: "雨", icon: "雨" },
        82: { text: "雨", icon: "雨" },
        85: { text: "雪", icon: "雪" },
        86: { text: "雪", icon: "雪" },
        95: { text: "雨", icon: "雨" },
        96: { text: "雨", icon: "雨" },
        99: { text: "雨", icon: "雨" }
      },
      // 你的原有图标（全部保留）
      weatherPic: {
        "晴": require("@/assets/realtime/weather-sunny.png"),
        "少云": require("@/assets/realtime/weather-sunny.png"),
        "晴间多云": require("@/assets/realtime/weather-cloudy.png"),
        "多云": require("@/assets/realtime/weather-cloudy.png"),
        "阴": require("@/assets/realtime/weather-overcast.png"),
        "有风": require("@/assets/realtime/weather-little-wind.png"),
        "平静": require("@/assets/realtime/weather-little-wind.png"),
        "微风": require("@/assets/realtime/weather-little-wind.png"),
        "和风": require("@/assets/realtime/weather-cool-breeze.png"),
        "清风": require("@/assets/realtime/weather-cool-breeze.png"),
        "强风": require("@/assets/realtime/weather-strong-breeze.png"),
        "劲风": require("@/assets/realtime/weather-strong-breeze.png"),
        "强风/劲风": require("@/assets/realtime/weather-strong-breeze.png"),
        "疾风": require("@/assets/realtime/weather-strong-breeze.png"),
        "大风": require("@/assets/realtime/weather-strong-breeze.png"),
        "烈风": require("@/assets/realtime/weather-strong-breeze.png"),
        "风暴": require("@/assets/realtime/weather-strong-breeze.png"),
        "狂爆风": require("@/assets/realtime/weather-strong-breeze.png"),
        "飓风": require("@/assets/realtime/weather-strong-breeze.png"),
        "热带风暴": require("@/assets/realtime/weather-strong-breeze.png"),
        "霾": require("@/assets/realtime/weather-haze.png"),
        "中度霾": require("@/assets/realtime/weather-moderate-haze.png"),
        "重度霾": require("@/assets/realtime/weather-heavy-haze.png"),
        "严重霾": require("@/assets/realtime/weather-heavy-haze.png"),
        "阵雨": require("@/assets/realtime/weather-thunderstorm.png"),
        "雷阵雨": require("@/assets/realtime/weather-thunderstorm.png"),
        "雷阵雨并伴有冰雹": require("@/assets/realtime/weather-thunderstorm-with-hail.png"),
        "小雨": require("@/assets/realtime/weather-light-rain.png"),
        "中雨": require("@/assets/realtime/weather-moderate-rain.png"),
        "大雨": require("@/assets/realtime/weather-rain.png"),
        "暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "大暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "特大暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "强阵雨": require("@/assets/realtime/weather-thunderstorm.png"),
        "强雷阵雨": require("@/assets/realtime/weather-thunderstorm.png"),
        "极端降雨": require("@/assets/realtime/weather-thunderstorm.png"),
        "毛毛雨": require("@/assets/realtime/weather-light-rain.png"),
        "细雨": require("@/assets/realtime/weather-light-rain.png"),
        "毛毛雨/细雨": require("@/assets/realtime/weather-light-rain.png"),
        "雨": require("@/assets/realtime/weather-rain.png"),
        "小雨-中雨": require("@/assets/realtime/weather-moderate-rain.png"),
        "中雨-大雨": require("@/assets/realtime/weather-rain.png"),
        "大雨-暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "暴雨-大暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "大暴雨-特大暴雨": require("@/assets/realtime/weather-cloudburst.png"),
        "雨雪天气": require("@/assets/realtime/weather-snow.png"),
        "雨夹雪": require("@/assets/realtime/weather-snow.png"),
        "阵雨夹雪": require("@/assets/realtime/weather-snow.png"),
        "冻雨": require("@/assets/realtime/weather-snow.png"),
        "雪": require("@/assets/realtime/weather-snow.png"),
        "阵雪": require("@/assets/realtime/weather-showery-snow.png"),
        "小雪": require("@/assets/realtime/weather-light-snow.png"),
        "中雪": require("@/assets/realtime/weather-moderate-snow.png"),
        "大雪": require("@/assets/realtime/weather-heavy-snow.png"),
        "暴雪": require("@/assets/realtime/weather-blizzard.png"),
        "小雪-中雪": require("@/assets/realtime/weather-moderate-snow.png"),
        "中雪-大雪": require("@/assets/realtime/weather-heavy-snow.png"),
        "大雪-暴雪": require("@/assets/realtime/weather-blizzard.png"),
        "浮尘": require("@/assets/realtime/weather-raise-dust.png"),
        "扬沙": require("@/assets/realtime/weather-raise-dust.png"),
        "沙尘暴": require("@/assets/realtime/weather-sandstorm.png"),
        "强沙尘暴": require("@/assets/realtime/weather-strong-sandstorm.png"),
        "龙卷风": require("@/assets/realtime/weather-strong-sandstorm.png"),
        "雾": require("@/assets/realtime/weather-fog.png"),
        "浓雾": require("@/assets/realtime/weather-heavy-fog.png"),
        "强浓雾": require("@/assets/realtime/weather-heavy-fog.png"),
        "轻雾": require("@/assets/realtime/weather-fog.png"),
        "大雾": require("@/assets/realtime/weather-thick-fog.png"),
        "特强浓雾": require("@/assets/realtime/weather-heavy-fog.png"),
        "热": require("@/assets/realtime/weather-sunny.png"),
        "冷": require("@/assets/realtime/weather-snow.png"),
        "未知": require("@/assets/realtime/weather-sunny.png"),
      },
      username: "",
    }
  },
  created() {
    this.reRoute();
    this.timeSetinterval = setInterval(() => {
      this.updateTime();
    }, 1000);

    if (sessionStorage.getItem("user")) {
      this.username = JSON.parse(sessionStorage.getItem("user")).name;
    } else {
      window.location.href = "/login";
    }
  },
  mounted() {
    // 先获取定位，再获取天气
    this.getCurrentLocation();
    
  },
  beforeUnmount() {
    clearInterval(this.timeSetinterval);
  },
  watch: {
    $route(to, from) {
      this.reRoute();
    }
  },
  methods: {
    updateTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.timenow = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    aquaLogout() {
      sessionStorage.clear();
      window.location.href = "/login";
    },

    // 1. 获取当前定位（经纬度）
    getCurrentLocation() {
    if (!navigator.geolocation) {
        console.warn("浏览器不支持地理定位，使用默认经纬度");
        this.getWeatherMsg();
        return;
      }

      const options = {
        enableHighAccuracy: true,   // 高精度
        timeout: 10000,              // 超时10秒
        maximumAge: 0                // 不使用缓存
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          // 定位成功：更新经纬度
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log("当前定位：", this.latitude, this.longitude);
          // 定位成功后再请求天气
          this.getWeatherMsg();
        },
        (error) => {
          // 定位失败：用默认经纬度
          console.error("定位失败：", error.message);
          this.getWeatherMsg();
        },
        options
      );
    },

    // 2. 用经纬度获取天气（Open-Meteo）
    async getWeatherMsg() {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${this.latitude}&longitude=${this.longitude}&current_weather=true`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP错误：${response.status}`);
        const data = await response.json();
        const currentWeather = data.current_weather;
        const weatherInfo = this.weatherCodeMap[currentWeather.weathercode] || { text: "未知", icon: "晴" };

        this.weather = {
          weather: weatherInfo.text,
          temperature: currentWeather.temperature.toFixed(1),
        };

        sessionStorage.setItem("weather", JSON.stringify(this.weather));
      } catch (error) {
        console.error("天气获取失败：", error);
        this.weather = { weather: "--", temperature: "--" };
      }
    },

    selectMenu(item) {
      if (this.activeMenu != item.label) {
        this.activeMenu = item.label;
        router.push(item.url);
      }
    },
    reRoute() {
      if (this.$route.path == "/") {
        router.push(this.menuList[0].url);
      } else {
        this.activeMenu = this.$route.name;
      }
    },
  }
}
</script>

<style scoped lang="scss">
body {
    font-family: Arial, sans-serif;
    background-color: #fff;
    margin: 0;
    padding: 0;
}

.total-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .total-header {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 20px);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding: 10px;
    background: #00000080;
    backdrop-filter: blur(10px);
    color: #ffffff;
    z-index: 3000;

    .header-center {
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 30%;
      min-width: 330px;
      justify-content: space-between;

      .center-menu {
        display: flex;
        flex-direction: row;
        height: 100%;

        .menu-img {
          display: block;
          margin-top: 10px;
          padding-bottom: 5px;
          height: 20px;
          width: auto;
          max-width: 100%;
          margin-right: 20px;
        }
      }
    }

  }

  .header-right {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 30%;
    min-width: 460px;
    justify-content: right;
    margin-left: 20px;
  }

  .total-bottom {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    position: relative;
    .total-left {
      height: 100%;
      border-right: 1px solid #dcdfe6;
      width: 240px;

      .total-left-header {
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .total-main {
      flex: 1;
      width: calc(100% - 300px);
      padding: 5px 20px;
      background: #f8f8f8;

      .total-main-bar {
        height: 20px;
        border-radius: 5px;
        width: calc(100%)
      }
    }
  }
}
.weatherimg{
  height:30px;width: 30px;

}
.weatherimgbox{
  height:100%;width: 24px;line-height: 60px;margin-right: 10px;
}

.avatarimg{
  height: 20px;width: 20px;display: block;margin-right: 10px;
}
</style>
